import React, {useState} from 'react';
import './calc/css/calc.css'; // main page gets this style also
import Header from '../core/Header';
import Footer from '../core/Footer';

// import './node/vendor/bootstrap/css/bootstrap.css';

const Calculator = () => {

  const [input, setInput] = useState("");
  const calcBtns = [];
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0, ".", " "].forEach(item => {
    calcBtns.push(
      <button
        onClick={e => {
          setInput(input + e.target.value);
        }}
        value={item}
        key={item}
      >
        {" "}
        {item}
      </button>
    );
  });

  return (
    <div>
    <Header>

    </Header>
    <div className="p-5 calcbg">
        <div className="wrapper2 ">

      {" "}
      <div className="show-input form-control p-3">
      
     {input}

      </div>
      <div className="digits flex">{calcBtns}</div>
      <div className="modifiers subgrid">
        {/* clear button */}

        <button onClick={() => setInput(input.substr(0, input.length - 1))}>
          Clear
        </button>

        {/* clear all */}
        <button onClick={() => setInput("")} value="">
          AC
        </button>
      </div>
      <div className="operations subgrid">
        {/* add button */}
        <button onClick={e => setInput(input + e.target.value)} value="+">
          +
        </button>

        {/* minus btn */}
        <button onClick={e => setInput(input + e.target.value)} value="-">
          {" "}
          -{" "}
        </button>

        <button onClick={e => setInput(input + e.target.value)} value="*">
          {" "}
          *
        </button>

        <button onClick={e => setInput(input + e.target.value)} value="/">
          {" "}
          /
        </button>
        {/* "=" btn */}
        <button
          onClick={e => {
            try {
              setInput(
                String(eval(input)).length > 3 &&
                  String(eval(input)).includes(".")
                  ? String(eval(input).toFixed(4))
                  : String(eval(input))
              );
            } catch (e) {
              console.log(e);
            }
          }}
          value="="
        >
          =
        </button>
      </div>
     
    </div>
    </div>
    <Footer></Footer>
    </div>
  );
}


export default Calculator;
  
